import { Component } from 'react';
import { RadioButton } from 'primereact/radiobutton';
import BranchToSectionMultiDDPreFill from '../../../../BaseDropdownComponents/BranchToSectionMultiDDPreFill';
import ClassetStudentSearchFilter from '../../../../Search/ClassetStudentSearchFilter';

class SearchFilters extends Component {
    render() {
        const {
            searchLevel,
            onSearchLevelChange,
            setDropdownValues
        } = this.props;

        return (
            <div className="ma-main">
                <div className="datatable-crud-demo ma-m30 mx-2 mb-5">
                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton 
                                inputId="ingredient1" 
                                onChange={() => onSearchLevelChange(1)} 
                                checked={searchLevel === 1} 
                            />
                        </div>
                        <div>
                            <BranchToSectionMultiDDPreFill 
                                selectedValue={searchLevel} 
                                setValues={setDropdownValues} 
                            />
                        </div>
                    </div>
                    <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton 
                                inputId="ingredient2" 
                                onChange={() => onSearchLevelChange(2)} 
                                checked={searchLevel === 2} 
                            />
                        </div>
                        <div className="field ml-4">
                            <ClassetStudentSearchFilter
                                ref={this.props.studentSearchRef}
                                selectedValue={searchLevel}
                                setValues={setDropdownValues}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchFilters;
